export default {
  computed: {
    pageTemplate() {
      if (
        this.category &&
        this.category.templateModel &&
        this.category.templateModel.templateModelId
      ) {
        if (this.category.templateModel.templateModelId == 250) {
          return () => import("@/components/category/category-main.vue");
        } else if (this.category.templateModel.templateModelId == 251) {
          return () => import("@/components/category/category-med.vue");
        } else if (this.category.templateModel.templateModelId == 252) {
          return () => import("@/components/category/category-med.vue");
        } else if (this.category.templateModel.templateModelId == 253) {
          return () => import("@/components/category/category-med.vue");
        } else if (this.category.templateModel.templateModelId == 254) {
          return () => import("@/components/category/category-med.vue");
        } else if (this.category.templateModel.templateModelId == 255) {
          return () => import("@/components/category/category-med.vue");
        } else if (this.category.templateModel.templateModelId == 256) {
          return () => import("@/components/category/category-med.vue");
        } else if (this.category.templateModel.templateModelId == 257) {
          return () => import("@/components/category/category-med.vue");
        } else if (this.category.templateModel.templateModelId == 258) {
          return () => import("@/components/category/category-med.vue");
        } else if (this.category.templateModel.templateModelId == 259) {
          return () => import("@/components/category/category-med.vue");
        } else if (this.category.templateModel.templateModelId == 150) {
          return () => import("@/components/category/category-main.vue");
        } else if (this.category.templateModel.templateModelId == 151) {
          return () => import("@/components/category/category-main.vue");
        } else if (this.category.templateModel.templateModelId == 152) {
          return () => import("@/components/category/category-main.vue");
        }
      }

      switch (this.category?.template) {
        case "catalog":
          return () => import("@/components/category/category-main.vue");
        case "products":
          return () => import("@/components/category/category-med.vue");
        case "special":
          return () => import("@/components/category/category-med.vue");
        case "custom":
          return () => import("@/components/category/category-med.vue");
        default:
          return () =>
            import(`@/components/category/${this.category?.template}.vue`);
      }
    }
  }
};
